// extracted by mini-css-extract-plugin
export default {"header":"AcceptWebInviteView_header__dFOFV","description":"AcceptWebInviteView_description__Tt0ao","link":"AcceptWebInviteView_link__urNuv"};